import { armorAPI } from '~/services/api';

export const get = () =>
  armorAPI.request({
    method: 'GET',
    url: `/setting/package-units`,
  });

export const put = (data) =>
  armorAPI.request({
    data,
    method: 'PUT',
    url: `/setting/package-units`,
  });
